// src/pages/DemoStaticPage.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const DemoStaticPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirige directamente al archivo HTML estático
    window.location.href = '/demo/index.html';
    
    // Opcional: Si necesitas manejar la navegación después
    const handleBack = () => navigate('/');
    window.addEventListener('popstate', handleBack);
    
    return () => window.removeEventListener('popstate', handleBack);
  }, [navigate]);

  return null; // No renderiza nada, solo maneja la redirección
};

export default DemoStaticPage;